document.addEventListener('DOMContentLoaded', function() {
  const optionSelectors = document.querySelectorAll('#variant-picker-selection .option-selector--size');
  
  optionSelectors.forEach(selector => {
    const inputs = selector.querySelectorAll('input[type="radio"]');
    const selectedValueSpan = selector.querySelector('[data-option-value]');
    
    // Update selected value when radio button changes
    inputs.forEach(input => {
      input.addEventListener('change', function() {
        if (this.checked) {
          selectedValueSpan.textContent = ` ${this.value}`;
        }
      });
    });
    
    // Set initial value
    const checkedInput = selector.querySelector('input[type="radio"]:checked');
    if (checkedInput) {
      selectedValueSpan.textContent = ` ${checkedInput.value}`;
    }
  });

  function showIntroText(variantId) {
    document.querySelectorAll('.variant-intro-text').forEach(function(div) {
      if (div.getAttribute('data-variant-id') == variantId) {
        div.style.display = '';
      } else {
        div.style.display = 'none';
      }
    });
  }

  document.addEventListener('change', function(e) {
    if (e.target.name === 'id') {
      showIntroText(e.target.value);
    }
  });

}); 